export default __webpack_public_path__ + "static/media/tab-connect-dashboard.e16cf6d5.png";